import { render, staticRenderFns } from "./StructuralDesign.vue?vue&type=template&id=f83ec038&scoped=true&"
var script = {}
import style0 from "./StructuralDesign.vue?vue&type=style&index=0&id=f83ec038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83ec038",
  null
  
)

export default component.exports